interface CreateMarkerOptions extends google.maps.MarkerOptions {
    onClick?: () => void;
}

export const storeMarkerIcon = (url: string, version: "control" | "b" = "control") =>
    ({
        url,
        scaledSize:
            version === "control" ? new google.maps.Size(24, 35) : new google.maps.Size(43, 43),
    }) as google.maps.Icon;

export const createMarker = ({
    icon,
    position,
    title,
    label,
    zIndex = 1,
    onClick,
    visible,
}: CreateMarkerOptions) => {
    const marker = new google.maps.Marker({
        position,
        icon,
        zIndex,
        title,
        label,
        visible,
    });

    if (onClick) {
        marker.addListener("click", onClick);
    }

    return marker;
};
